/**
 * A reopen ACK can release legacy production masters that were queued while
 * the day was optimistically open. They must get a whole FIFO drain pass before
 * plan/stock/close lanes continue, otherwise a same-tick close can sign the day
 * again first.
 */
export function mustYieldForLegacyAfterReopenAckV1(
  runnableLegacyCount: number,
): boolean {
  return Number.isSafeInteger(runnableLegacyCount)
    && runnableLegacyCount > 0;
}
